import { CookiesGroups, OneTrustService } from '@altack/ngx-onetrust';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { LanguageService } from '@spartacus/core';
import { BehaviorSubject, Observable, Subject, takeUntil } from 'rxjs';
import { EnvironmentService } from '../environment.service';
import { isPlatformBrowser } from '@angular/common';

@Injectable({ providedIn: 'root' })
export class kbOneTrustInitService {
  private consentSubject = new BehaviorSubject<Map<CookiesGroups, boolean>>(new Map());
  private unsubscribe$ = new Subject<void>();
  platformId = inject(PLATFORM_ID);
  constructor(
    private oneTrust: OneTrustService,
    private langService: LanguageService,
    private enviornmentService: EnvironmentService
  ) { }

  consentChangedCustom$(): Observable<Map<CookiesGroups, boolean>> {
    return this.consentSubject.asObservable();
  }

  updateConsent(consent: Map<CookiesGroups, boolean>) {
    this.consentSubject.next(consent);
  }

  public load() {
    const domainScriptId = this.enviornmentService.getConfig()?.oneTrustKey;
    return this.oneTrust.loadOneTrust(domainScriptId);
  }
  public consent() {
    this.oneTrust
      .consentChanged$()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((x) => {
        this.updateConsent(x);
        if (isPlatformBrowser(this.platformId)) {
          document.documentElement.style.overflow = ''; // For the <html> tag
          document.body.style.overflow = '';
        }
      });
    return this.oneTrust.consentChanged$();
  }

  public translate() {
    this.langService.getActive().subscribe((x) => {
      const y = x.split('_')[0];
      return this.oneTrust.translateBanner(y, true);
    });
  }
}
